import { render, staticRenderFns } from "./CreateNewGhazal.vue?vue&type=template&id=4be85d90&"
import script from "./CreateNewGhazal.vue?vue&type=script&lang=js&"
export * from "./CreateNewGhazal.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewGhazal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports